import { SvgIconProps } from '@mui/material';

const EngFlagIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={18}
      height={18}
      x={1}
      y={1}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <circle cx={10} cy={10} r={9} fill="#D1D1D1" />
    </mask>
    <g mask="url(#a)">
      <path fill="#0064C5" d="M0 0h20v20H0z" />
      <path fill="#fff" d="M8 20V0h4v20z" />
      <path fill="#B60000" d="M9 19V-1h2v20z" />
      <path fill="#fff" d="m.28 13.861 17.321-10 1.5 2.598-17.32 10z" />
      <path
        fill="#B60000"
        d="m1.5 14.679 6.279-3.625.5.866L2 15.545zM8.07 10l10.427-6.02.5.866-10.427 6.02zM13.375 10.65l8.53 4.926-.5.866-8.53-4.925z"
      />
      <path fill="#fff" d="m1.867 3.54 17.32 10-1.5 2.599-17.32-10z" />
      <path fill="#B60000" d="m2.164 5 16.166 9.333-.5.866L1.664 5.866z" />
      <path fill="#fff" d="M0 8h20v4H0z" />
      <path fill="#B60000" d="M0 9h20v2H0z" />
    </g>
  </svg>
);
export default EngFlagIcon;
